module.exports = __webpack_public_path__ + "../../../vue-resources/personal-account/dist/img/promotion_pink.png";